<template>
	<img v-if="src" :src="src" :alt="codice" class="bd-flag" />
	<span v-else class="bd-code">{{ String(codice || '?').toUpperCase() }}</span>
</template>

<script>
import { bandiera } from './formato';

// bandiera del paese; se l'immagine non c'e' mostra il codice (es. RS) invece della mappa generica
export default {
	name: 'Bandiera',
	props: {
		codice: { type: String, default: '' },
	},
	computed: {
		src() {
			return bandiera(this.codice);
		},
	},
};
</script>

<style scoped>
.bd-flag {
	width: 20px;
	height: 14px;
	object-fit: cover;
	border-radius: 2px;
	box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
	vertical-align: middle;
	flex: 0 0 auto;
}
.bd-code {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 14px;
	border-radius: 2px;
	background: #e1e7ef;
	color: #1f2d3d;
	font-size: 8px;
	font-weight: 700;
	letter-spacing: 0.02em;
	vertical-align: middle;
	flex: 0 0 auto;
}
</style>
